import moment from 'moment';
import { IFilterCorporateTimesheetTable, IFilterTimesheetTable } from '../../models';
import {
  COMPANY_LIST_SUCCESS,
  CONFIG_STATUS_SUCCESS,
  CUSTOMER_DROP_DOWN_SUCCESS,
  PAY_RATE_OVERRIDE_SUCCESS,
  REMEMBER_ACTIONABLE_TIMESHEET_FILTER,
  REMEMBER_AWAITING_CUSTOMER_APPROVAL_FILTER,
  REMEMBER_CORPORATE_ALL_TIMESHEET_FILTER,
  REMEMBER_EXCEPTION_TIMESHEET_FILTER,
  REMEMBER_EXECUTIVE_DASHBOARD_FILTER,
  REMEMBER_GF_ALL_TIMESHEET_FILTER,
  REMEMBER_READY_TO_INVOICE_FILTER,
  SET_CONNECTION_STATUS,
  SET_DISPLAY_BANNER,
  SET_HOLLIDAY_LIST,
  SET_ISBLOCKING,
  SET_ISFETCHING,
  SET_MY_SPACE,
  SET_NOTIFICATIONS,
  SET_RECENT_NOTIFICATION,
  SET_ROLE_PERMISSIONS,
  SET_SHOW_SIDE_LIST,
  SHIFT_TIME_TYPE_SUCCESS,
  SHIFT_TYPE_SUCCESS,
  STATE_LIST_SUCCESS,
  TIMESHEET_DROP_DOWN_SUCCESS,
  REMEMBER_GF_BILLABLE_TIMESHEET_FILTER,
  UKG_ROLES_SUCCESS,
  AUTOMATION_TYPES_SUCCESS,
  SET_ACTIVE_USERS_COUNT,
} from '../actions/common';
export interface ICommonState {
  isFetching: boolean;
  isBlocking: boolean;
  rolePermissions: any;
  configStatuses: any[];
  shiftTypes: any[];
  customerDropDown: any[];
  timesheetDropDown: any[];
  shiftTimeType: any[];
  payrateOverrideList: any[];
  gfAllTimesheetFilters: any;
  gfBillableTimesheetFilters: any;
  awaitingCustomerApprovalTimesheetFilters: any;
  readyToInvoiceTimesheetFilters: any;
  corporateAllTimesheetFilters: any;
  notifications: any[];
  connectionStatus: boolean;
  recentNotification: any;
  getExecutiveDashboardFilter: any;
  actionableTimesheetFilter: any;
  exceptionTimesheetFilter: any;
  mySpace: any;
  holidayList: any[];
  displayBanner: boolean;
  showSideList: boolean;
  stateList: any[];
  ukgRoles: any[];
  companies: any[];
  crossCompanyAccessError: boolean;
  automationTypes: any[];
  activeUsersCount: number;
}
export const getInitialState = () => ({
  mySpace: {},
  isFetching: false,
  isBlocking: false,
  rolePermissions: {},
  notifications: [],
  recentNotification: {},
  configStatuses: [],
  shiftTypes: [],
  customerDropDown: [],
  timesheetDropDown: [],
  shiftTimeType: [],
  payrateOverrideList: [],
  gfAllTimesheetFilters: {
    customerIds: [],
    jobNumbers: [],
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
    pageSize: 500,
    currentPage: 1,
    employeeNos: [],
    shiftEmployeeNos: [],
    divisions: [],
    timesheetStatuses: [],
    weekFilter: 2,
    timesheetNo: '',
    inActiveGF: false,
    isGoBack: false,
  },
  gfBillableTimesheetFilters: {
    customerIds: [],
    jobNumbers: [],
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
    pageSize: 500,
    currentPage: 1,
    employeeNos: [],
    shiftEmployeeNos: [],
    divisions: [],
    timesheetStatuses: [],
    weekFilter: 2,
    timesheetNo: '',
    inActiveGF: false,
  },
  awaitingCustomerApprovalTimesheetFilters: {
    customerIds: [],
    jobNumbers: [],
    contractTypes: null,
    pageSize: -1,
    currentPage: 1,
    weekFilter: 2,
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
    divisions: [],
    employeeNos: [],
  },
  readyToInvoiceTimesheetFilters: {
    customerIds: [],
    jobNumbers: [],
    contractTypes: null,
    pageSize: -1,
    currentPage: 1,
    weekFilter: 2,
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
    divisions: [],
    employeeNos: [],
  },
  corporateAllTimesheetFilters: {
    startDate: moment().startOf('month').toDate(),
    endDate: moment().endOf('month').toDate(),
    pageSize: 30,
    currentPage: 1,
    weekFilter: 2,
    divisions: [],
    managers: [],
    employeeNos: [],
    timesheetStatuses: [],
    timesheetNo: '',
  },
  connectionStatus: false,
  getExecutiveDashboardFilter: {},
  actionableTimesheetFilter: {
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
    weekFilter: 2,
  },
  exceptionTimesheetFilter: {},
  holidayList: [],
  displayBanner: false,
  showSideList: true,
  stateList: [],
  ukgRoles: [],
  companies: [],
  crossCompanyAccessError: false,
  automationTypes: [],
  activeUsersCount: 0,
});

const commonReducer = (state: ICommonState = getInitialState(), action: any) => {
  switch (action.type) {
    case SET_ISFETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    case SET_ISBLOCKING:
      return {
        ...state,
        isBlocking: action.payload,
      };
    case SET_ROLE_PERMISSIONS:
      return {
        ...state,
        rolePermissions: action.payload,
      };
    case SET_MY_SPACE:
      return {
        ...state,
        mySpace: action.payload,
      };
    case CONFIG_STATUS_SUCCESS:
      return {
        ...state,
        configStatuses: action.payload,
      };
    case SHIFT_TYPE_SUCCESS:
      return {
        ...state,
        shiftTypes: action.payload,
      };
    case CUSTOMER_DROP_DOWN_SUCCESS:
      return {
        ...state,
        customerDropDown: action.payload,
      };
    case TIMESHEET_DROP_DOWN_SUCCESS:
      return {
        ...state,
        timesheetDropDown: action.payload,
      };
    case SHIFT_TIME_TYPE_SUCCESS:
      return {
        ...state,
        shiftTimeType: action.payload,
      };
    case PAY_RATE_OVERRIDE_SUCCESS:
      return {
        ...state,
        payrateOverrideList: action.payload,
      };
    case REMEMBER_GF_ALL_TIMESHEET_FILTER:
      return {
        ...state,
        gfAllTimesheetFilters: action.payload as IFilterTimesheetTable,
      };
    case REMEMBER_GF_BILLABLE_TIMESHEET_FILTER:
      return {
        ...state,
        gfBillableTimesheetFilters: action.payload as IFilterTimesheetTable,
      };
    case REMEMBER_AWAITING_CUSTOMER_APPROVAL_FILTER:
      return {
        ...state,
        awaitingCustomerApprovalTimesheetFilters: {
          ...state.awaitingCustomerApprovalTimesheetFilters,
          ...action.payload,
        },
      };

    case REMEMBER_READY_TO_INVOICE_FILTER:
      return {
        ...state,
        readyToInvoiceTimesheetFilters: {
          ...state.readyToInvoiceTimesheetFilters,
          ...action.payload,
        },
      };

    case REMEMBER_CORPORATE_ALL_TIMESHEET_FILTER:
      return {
        ...state,
        corporateAllTimesheetFilters: action.payload as IFilterCorporateTimesheetTable,
      };
    case SET_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      };
    case SET_CONNECTION_STATUS:
      return {
        ...state,
        connectionStatus: action.payload,
      };
    case SET_RECENT_NOTIFICATION:
      return {
        ...state,
        recentNotification: action.payload,
      };
    case REMEMBER_EXECUTIVE_DASHBOARD_FILTER:
      return {
        ...state,
        getExecutiveDashboardFilter: action.payload,
      };
    case REMEMBER_ACTIONABLE_TIMESHEET_FILTER:
      return {
        ...state,
        actionableTimesheetFilter: action.payload,
      };
    case REMEMBER_EXCEPTION_TIMESHEET_FILTER:
      return {
        ...state,
        exceptionTimesheetFilter: action.payload,
      };
    case SET_HOLLIDAY_LIST:
      return {
        ...state,
        holidayList: action.payload,
      };
    case SET_DISPLAY_BANNER:
      return {
        ...state,
        displayBanner: action.payload,
      };
    case SET_SHOW_SIDE_LIST:
      return {
        ...state,
        showSideList: action.payload,
      };
    case STATE_LIST_SUCCESS:
      return {
        ...state,
        stateList: action.payload,
      };
    case UKG_ROLES_SUCCESS:
      return {
        ...state,
        ukgRoles: action.payload,
      };
    case COMPANY_LIST_SUCCESS:
      return {
        ...state,
        companies: action.payload,
      };
    case 'SET_CROSS_COMPANY_ACCESS_ERROR':
      return {
        ...state,
        crossCompanyAccessError: action.payload,
      };
    case AUTOMATION_TYPES_SUCCESS:
      return {
        ...state,
        automationTypes: action.payload,
      };
    case SET_ACTIVE_USERS_COUNT:
      return {
        ...state,
        activeUsersCount: action.payload,
      };
    default:
      return state;
  }
};

export default commonReducer;
